import { dom } from '@fortawesome/fontawesome-svg-core'
;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './reviews-block.scss')]).then(() => {
    $('.widget.reviews-block').each(function (i, el) {
      $(el).data('widget', new ReviewsBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function ReviewsBlock(el, Swiper) {
  const self = this
  self.el = $(el)
  self.isLoaded = false
  self.reviewCardTemplate = require('./reviews-block-card.hbs')

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ReviewsBlock init', self)
    }

    self.fetchReviews()
  }

  self.hideWidget = function () {
    console.warn('No reviews to display, hiding widget.', self.el)
    self.el.addClass('!hidden')
    self.el.css('opacity', 0)
  }

  self.fetchReviews = function () {
    if (self.isLoaded) {
      return
    }
    console.log('fetchReviews')

    $.ajax({
      url: self.el.attr('data-api-endpoint'),
      type: self.el.attr('data-api-method'),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        console.log('Reviews data received', data)
        if (data.success) {
          self.el.css('opacity', 1)
          self.hydrateReviewsHeader(data)
          self.renderReviews(data.reviews)
        } else {
          self.hideWidget()
        }

        self.isLoaded = true
      })
      .fail(function (err) {
        self.hideWidget()
        console.error(err)
      })
  }

  self.hydrateReviewsHeader = function (data) {
    // Convert overallRating (out of 10) to rating out of 5
    const rawRating = data.overallRating
    let displayRating = 'N/A'
    if (typeof rawRating === 'number') {
      const score = rawRating / 2
      const rating = Number.isInteger(score) ? score : score.toFixed(1)
      displayRating = `${rating} / 5`
    }
    console.log('displayRating', displayRating)

    // Update average rating in the header
    const averageRatingEl = self.el.find('.js-overall-rating-value')
    averageRatingEl.text(displayRating)

    const reviewsCountEl = self.el.find('.js-reviews-count')
    reviewsCountEl.text(data.reviewCount || 'N/A')
  }

  self.renderReviews = function (reviewsData) {
    console.log('Rendering reviews', reviewsData)
    const reviewsContainer = self.el.find('.swiper-wrapper')

    // Render reviews items
    const reviewsFragment = new DocumentFragment()
    reviewsData.forEach((review) => {
      // Convert overallRating (out of 10) to rating out of 5
      const rawRating = review.rating
      let displayRating = 'N/A'
      if (typeof rawRating === 'number') {
        const score = rawRating / 2
        const rating = Number.isInteger(score) ? score : score.toFixed(1)
        displayRating = `${rating} / 5`
      }

      // Render HTML
      const template = document.createElement('template')
      template.innerHTML = self.reviewCardTemplate({ review, displayRating })
      reviewsFragment.append(template.content)
    })

    // Append reviews to DOM
    reviewsContainer.empty()
    reviewsContainer.append(reviewsFragment)

    // Init swiper after all slides are added
    self.initReviewsSwiper()
  }

  self.initReviewsSwiper = function () {
    const swiperEl = self.el.find('.swiper')
    // Find all slides in the swiper
    const slides = swiperEl.find('.swiper-slide')
    swiperEl.attr('data-slides-count', slides.length)
    // Only setup navigation if there are more than 4 slides
    let navigation = {}
    if (slides.length > 4) {
      // Buttons are not within the swiperEl, but within the parent element
      const nextEl = self.el.find('.swiper-button-next')
      const prevEl = self.el.find('.swiper-button-prev')

      navigation = {
        nextEl,
        prevEl,
      }

      // Show the navigation buttons
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
    }

    self.swiper = new Swiper(swiperEl, {
      loop: false,
      autoHeight: false,
      watchOverflow: true,
      slidesPerView: 'auto',
      navigation,
      pagination: {
        el: swiperEl.find('> .swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }
}
